import { RequestKind, boolean, string } from '@sb/library/base';
import { CustomEmailTemplateDisplayItem, CustomEmailTemplateInputItem, CustomEmailTemplateUpdateItem, DisplayItemCollection, EmailPreviewDisplayItem, EmailPreviewInputItem, MessageTemplatePlaceholder, SMSPreviewDisplayItem, SMSPreviewInputItem, SystemEmailTemplateDisplayItem, SystemEmailTemplateUpdateItem, SystemSMSTemplateDisplayItem, SystemSMSTemplateUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace MessageTemplateRoutes {
    export namespace SystemEmail {
        export const Get = ApiRoute.Define({
            URL: (templateType: string) => `systememailtemplates/${templateType}`,
            Kind: RequestKind.Get,
            ResultType: SystemEmailTemplateDisplayItem
        });

        export const GetAll = ApiRoute.Define({
            URL: 'systememailtemplates',
            Kind: RequestKind.Get,
            ResultType: DisplayItemCollection<SystemEmailTemplateDisplayItem>
        });

        export const GetPlaceholders = ApiRoute.Define({
            URL: (templateType: string) => `systememailtemplates/${templateType}/placeholders`,
            Kind: RequestKind.Get,
            ResultType: Array<MessageTemplatePlaceholder>
        });

        export const Update = ApiRoute.Define({
            URL: (templateType: string) => `systememailtemplates/${templateType}`,
            Kind: RequestKind.Put,
            BodyType: SystemEmailTemplateUpdateItem,
            ResultType: boolean
        });

        export const Preview = ApiRoute.Define({
            URL: 'systememailtemplates/preview',
            Kind: RequestKind.Post,
            BodyType: EmailPreviewInputItem,
            ResultType: EmailPreviewDisplayItem
        });
    }

    export namespace CustomEmail {
        export const Get = ApiRoute.Define({
            URL: (templateID: string) => `customemailtemplates/${templateID}`,
            Kind: RequestKind.Get,
            ResultType: CustomEmailTemplateDisplayItem
        });

        export const GetAll = ApiRoute.Define({
            URL: 'customemailtemplates',
            Kind: RequestKind.Get,
            ResultType: DisplayItemCollection<CustomEmailTemplateDisplayItem>
        });

        export const GetPlaceholders = ApiRoute.Define({
            URL: 'customemailtemplates/placeholders',
            Kind: RequestKind.Get,
            ResultType: Array<MessageTemplatePlaceholder>
        });

        export const Add = ApiRoute.Define({
            URL: 'customemailtemplates',
            Kind: RequestKind.Post,
            BodyType: CustomEmailTemplateInputItem,
            ResultType: string
        });

        export const Update = ApiRoute.Define({
            URL: (templateID: string) => `customemailtemplates/${templateID}`,
            Kind: RequestKind.Put,
            BodyType: CustomEmailTemplateUpdateItem,
            ResultType: boolean
        });

        export const Delete = ApiRoute.Define({
            URL: (templateID: string) => `customemailtemplates/${templateID}`,
            Kind: RequestKind.Delete,
            ResultType: boolean
        });

        export const Preview = ApiRoute.Define({
            URL: 'customemailtemplates/preview',
            Kind: RequestKind.Post,
            BodyType: EmailPreviewInputItem,
            ResultType: EmailPreviewDisplayItem
        });
    }

    export namespace SystemSMS {
        export const Get = ApiRoute.Define({
            URL: (templateType: string) => `systemsmstemplates/${templateType}`,
            Kind: RequestKind.Get,
            ResultType: SystemSMSTemplateDisplayItem
        });

        export const GetAll = ApiRoute.Define({
            URL: 'systemsmstemplates',
            Kind: RequestKind.Get,
            ResultType: DisplayItemCollection<SystemSMSTemplateDisplayItem>
        });

        export const GetPlaceholders = ApiRoute.Define({
            URL: (templateType: string) => `systemsmstemplates/${templateType}/placeholders`,
            Kind: RequestKind.Get,
            ResultType: Array<MessageTemplatePlaceholder>
        });

        export const Update = ApiRoute.Define({
            URL: (templateType: string) => `systemsmstemplates/${templateType}`,
            Kind: RequestKind.Put,
            BodyType: SystemSMSTemplateUpdateItem,
            ResultType: boolean
        });

        export const Preview = ApiRoute.Define({
            URL: 'systemsmstemplates/preview',
            Kind: RequestKind.Post,
            BodyType: SMSPreviewInputItem,
            ResultType: SMSPreviewDisplayItem
        });
    }
}
